import React from 'react'
import styled from 'styled-components'

import { shortDate } from 'helpers/formatters'

import Body from './Body'

import { color } from 'styles/colors'

type Props = React.PropsWithChildren<{
  className?: string
}>

type SiteMessageProps = Props & {
  messageType: string
}

type PublishedDateProps = {
  publishedAt: string
}

const SiteMessage = ({ children, messageType, className = '', ...props }: SiteMessageProps) => <S.SiteMessage {...{ className, messageType, ...props }}>{children}</S.SiteMessage>
SiteMessage.Body = Body
SiteMessage.PublishedDate = ({ publishedAt }: PublishedDateProps) => (<S.PublishedDate>{shortDate(publishedAt)}</S.PublishedDate>)

export default SiteMessage

const S = {
  SiteMessage: styled.div.withConfig({
    shouldForwardProp: (prop) => !['messageType'].includes(prop)
  })<{ messageType: string }>`
    width: 100%;
    padding: 10px 0 10px 10px;
    background-color: ${({ messageType }) => (messageType === 'info'
    ? color('siteMessageInfoBackground')
    : color('siteMessageWarningBackground')
  )};
  `,
  PublishedDate: styled.div`
    float: right;
    font-weight: bold;
    color: ${color('ancillaryText')};
    font-size: 13px;
    margin: -10px 3px;
  `
}
